import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Container, Divider, Grid, IconButton, InputAdornment, ListItem, Paper, TablePagination, TextField, Typography, makeStyles, ButtonGroup } from "@material-ui/core";
import { HeaderBlock } from '../../components/header-block/HeaderBlock';
import { useSelector, useDispatch } from 'react-redux';
import PageContainer from '../../components/page-container/PageContainer';
import { Loading } from '../../components/loading/Loading';
import { PagePlaceholder } from '../../components/page-placeholder/PagePlaceholder';
import SimpleTable from '../../components/table/Table';
import { getIcon } from '../../icon/icon';
import Search from '../../components/search/Search';
import { getPriceLists, deletePriceList } from '../../state/actions/PriceListsActions';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({

})

function ListPriceListsPage(props) {
    const priceLists = useSelector(state => state.PriceListsReducer.priceLists)

    const classes = useStyles()

    const [loading, setLoading] = useState(false)
    const [originalData, setOriginalData] = useState([])
    const [searchedData, setSearchedData] = useState([])
    const [selected, setSelected] = useState([])
    const [deleteAlertShowing, setDeleteAlertShowing] = useState(false)

    const [t, i18n] = useTranslation()
    const dispatch = useDispatch()

    useEffect(() => {
        setLoading(true)
        dispatch(getPriceLists(false, () => {
            setLoading(false)
        }))
    }, [])

    useEffect(() => {
        setSearchedData(createData(priceLists))
        setOriginalData(createData(priceLists))
    }, [priceLists])

    function createData(providedPriceLists) {
        if (providedPriceLists != null) {
            return Object.keys(providedPriceLists).map(priceListId => {
                var priceList = providedPriceLists[priceListId];

                return {
                    id: priceList.id,
                    name: priceList.Name,
    
                };
            });
        }

        return {};
    }

    function createCells(headers) {
        let cells = [];

        headers.forEach(header => {
            let cell = {};

            cell.id = header.id;

            cell.handleClick = (event, row) => {
                props.history.push(`/price-lists/${row.id}`);
            };

            cell.align = header.align;
            cell.clickable = header.clickable;
            cell.type = header.type;

            cells.push(cell);
        });

        return cells;
    }

    function createHeaders() {
        return [
            {
                id: "name",
                clickable: true,
                align: "left",
                label: t('common.name'),
                type: "label"
            },
            {
                id: "id",
                clickable: false,
                align: "left",
                label: t('price-list.price-list-id'),
                type: "label"
            }
        ];
    }

    function renderTable() {
        const headers = createHeaders();
        const cells = createCells(headers);

        if (Array.isArray(searchedData)) {
            if (searchedData.length > 0) {
                return (
                    <SimpleTable
                        isSelectable={true}
                        handleSelection={selectedItems => setSelected(selectedItems)}
                        dataId={"id"}
                        cells={cells}
                        headers={headers}
                        rows={searchedData}
                    />
                );
            } else {
                return showPlaceholder();
            }
        } else {
            return showPlaceholder();
        }
    }

    function showPlaceholder() {
        return (
            <PagePlaceholder
                image={getIcon("dollar.svg")}
                text={t('price-list.none-found')}
            />
        );
    }

    function handleDelete() {
        setDeleteAlertShowing(false);
        
        dispatch(deletePriceList(selected, () => {
            // Delete price lists...
        }))
    }

    function alertDialog() {
        return (
            <AlertDialog
                title={t("common.remove-question")}
                description={t("common.remove-description")}
                options={[
                    {
                        label: t('common.cancel'),
                        action: () => setDeleteAlertShowing(false)
                    },
                    { label: t('common.delete'), action: () => handleDelete() }
                ]}
                isOpen={deleteAlertShowing}
            />
        );
    }

    return (
        <Box>
            { alertDialog() }
            <HeaderBlock
                title={t('price-list.price-lists')}
                right={
                    <Grid container spacing={2} alignItems="center" justify="flex-end">
                        <Grid item>
                            <Search
                                searchField={"name"}
                                secondaryFields={["id"]}
                                returnSearchMatches={data => {
                                    setSearchedData(data)
                                }}
                                data={originalData}
                                searchTitle={t('price-list.search')}
                            />
                        </Grid>
                        <Grid item>
                            <ButtonGroup>
                                <Button
                                    disabled={selected.length === 0}
                                    onClick={() => setDeleteAlertShowing(true)}
                                    variant="outlined"
                                    color="primary"
                                >
                                    {t('common.delete')}
                                </Button>
                                <Button
                                    onClick={() => props.history.push("/price-lists/create")}
                                    variant="outlined"
                                    color="secondary"
                                >
                                    {t('price-list.new-rrp-price-list')}
                                </Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                }
            />

            <PageContainer hasFooter>
                {loading ? <Loading /> : renderTable()}
            </PageContainer>
        </Box >
    )
}

export default ListPriceListsPage
